import { noAuthRoute } from '@/router/guards/auth'
import VehicleSoftwareRegister from '@/views/forms/VehicleSoftwareRegister.vue'

export default {
  path: '/formulario-cadastro-veiculo-software',
  name: 'form-register-vehicle-software',
  component: VehicleSoftwareRegister,
  meta: {
    noAuth: true
  },

  beforeEnter (to, from, next) {
    const canEnter = noAuthRoute()

    if (canEnter) {
      return next(true)
    }

    next('/main')
  }
}
